import React from 'react';
import PropTypes from 'prop-types';
import { postData } from './utils';
import Form from './Form';
import styles from './styles';

const CoolForm = ({ title }) => (
  <Form onSubmit={formData => postData(formData)} source={title}>
    {({ submitting }) => (
      <Form.Fetch url="https://gdpr-service.herokuapp.com/is-gdpr">
        {({ isGDPR, loading }) => (
          <div>
            <Form.Group>
              <Form.Input
                type="text"
                name="company"
                placeholder="Company Name"
                disabled={loading || submitting}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                type="text"
                name="website"
                placeholder="Website"
                disabled={loading || submitting}
                small
                left
              />
              <Form.Input
                type="text"
                name="contact"
                placeholder="Contact Name"
                disabled={loading || submitting}
                small
                right
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                type="email"
                name="email"
                placeholder="Email"
                disabled={loading || submitting}
                small
                left
                required
              />
              <Form.Input
                type="text"
                name="phone"
                placeholder="Phone"
                disabled={loading || submitting}
                small
                right
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                type="text"
                name="city"
                placeholder="City"
                disabled={loading || submitting}
                small
                left
              />
              <Form.Input
                type="text"
                name="country"
                placeholder="Country"
                disabled={loading || submitting}
                small
                right
              />
            </Form.Group>
            <Form.Group>
              <Form.TextArea
                name="msg"
                placeholder="Brief description of partner opportunity..."
                disabled={loading || submitting}
              />
            </Form.Group>
            {isGDPR && (
              <div style={styles.gdpr.wrapper}>
                <p>You hate junk? So do we.</p>
                <p>
                  We&apos;d love it if you ticked the box below so we can continue sending this kind
                  of content your way. You can always change your mind and opt out at any time. (And
                  if you think what we’re sending IS junk, please let us know so we can fix it.)
                </p>
                <div>
                  <Form.ConsentRadioButton value="yes" id="consent-accepted">
                    Email me about product updates, learning resources, feedback surveys, special
                    offers and events.
                  </Form.ConsentRadioButton>
                  <Form.ConsentRadioButton value="no" id="consent-rejected">
                    No, please just send me this one resource.
                  </Form.ConsentRadioButton>
                </div>
              </div>
            )}
            <Form.Group>
              <Form.SubmitButton disabled={loading || submitting}>
                {submitting ? 'Sending...' : title}
              </Form.SubmitButton>
            </Form.Group>
          </div>
        )}
      </Form.Fetch>
    )}
  </Form>
);

CoolForm.propTypes = {
  title: PropTypes.string.isRequired
};

export default CoolForm;



// WEBPACK FOOTER //
// ./src/pages/partners/components/Form/index.js